// Gamification System for ISO 42001 Assessment

export const achievements = [
  {
    id: 'first-step',
    title: '🎯 First Step',
    description: 'Started your ISO 42001 assessment journey',
    requirement: 'Answer first question',
    points: 10,
    icon: '🎯'
  },
  {
    id: 'clause-complete',
    title: '📋 Clause Champion',
    description: 'Completed your first ISO 42001 clause',
    requirement: 'Complete any clause',
    points: 25,
    icon: '📋'
  },
  {
    id: 'half-way',
    title: '⚡ Halfway Hero',
    description: 'You\'re halfway through the assessment!',
    requirement: 'Complete 50% of questions',
    points: 50,
    icon: '⚡'
  },
  {
    id: 'full-assessment',
    title: '🏆 Assessment Master',
    description: 'Completed the full ISO 42001 assessment',
    requirement: 'Answer all questions',
    points: 100,
    icon: '🏆'
  },
  {
    id: 'perfect-clause',
    title: '💯 Perfect Clause',
    description: 'Achieved 100% compliance on a clause',
    requirement: 'Score 100% on any clause',
    points: 75,
    icon: '💯'
  },
  {
    id: 'action-taker',
    title: '💪 Action Taker',
    description: 'Added your first quick win to action plan',
    requirement: 'Add 1 quick win',
    points: 20,
    icon: '💪'
  },
  {
    id: 'strategic-planner',
    title: '📈 Strategic Planner',
    description: 'Created a comprehensive action plan',
    requirement: 'Add 10+ quick wins',
    points: 60,
    icon: '📈'
  },
  {
    id: 'pdf-expert',
    title: '📄 Documentation Pro',
    description: 'Downloaded your assessment report',
    requirement: 'Generate PDF report',
    points: 30,
    icon: '📄'
  },
  {
    id: 'compliance-champion',
    title: '🌟 Compliance Champion',
    description: 'Achieved 85%+ overall compliance',
    requirement: 'Score 85%+',
    points: 150,
    icon: '🌟'
  }
];

export const progressMilestones = [
  { threshold: 10, message: '🌱 Great start! Keep going!', color: 'text-green-400' },
  { threshold: 25, message: '💪 You\'re making progress!', color: 'text-blue-400' },
  { threshold: 50, message: '⚡ Halfway there!', color: 'text-yellow-400' },
  { threshold: 75, message: '🔥 Almost done!', color: 'text-orange-400' },
  { threshold: 100, message: '🎉 Assessment Complete!', color: 'text-cyan-400' }
];

export const calculateProgress = (auditResponses, totalQuestions) => {
  const answeredCount = Object.keys(auditResponses).length;
  return Math.round((answeredCount / totalQuestions) * 100);
};

export const checkAchievements = (auditResponses, auditClauses, actionPlan, existingAchievements = []) => {
  const newAchievements = [...existingAchievements];
  const totalQuestions = auditClauses.reduce((sum, clause) => sum + clause.questions.length, 0);
  const answeredCount = Object.keys(auditResponses).length;
  const progressPercent = (answeredCount / totalQuestions) * 100;
  
  // First Step
  if (answeredCount >= 1 && !newAchievements.find(a => a.id === 'first-step')) {
    newAchievements.push(achievements.find(a => a.id === 'first-step'));
  }
  
  // Clause Complete
  const completedClauses = auditClauses.filter(clause => 
    clause.questions.every(q => auditResponses[q.q] !== undefined)
  );
  if (completedClauses.length >= 1 && !newAchievements.find(a => a.id === 'clause-complete')) {
    newAchievements.push(achievements.find(a => a.id === 'clause-complete'));
  }
  
  // Halfway Hero
  if (progressPercent >= 50 && !newAchievements.find(a => a.id === 'half-way')) {
    newAchievements.push(achievements.find(a => a.id === 'half-way'));
  }
  
  // Assessment Master
  if (progressPercent === 100 && !newAchievements.find(a => a.id === 'full-assessment')) {
    newAchievements.push(achievements.find(a => a.id === 'full-assessment'));
  }
  
  // Perfect Clause
  const perfectClauses = completedClauses.filter(clause => {
    const yesCount = clause.questions.filter(q => auditResponses[q.q] === 'yes').length;
    return yesCount === clause.questions.length;
  });
  if (perfectClauses.length >= 1 && !newAchievements.find(a => a.id === 'perfect-clause')) {
    newAchievements.push(achievements.find(a => a.id === 'perfect-clause'));
  }
  
  // Action Taker
  if (actionPlan.length >= 1 && !newAchievements.find(a => a.id === 'action-taker')) {
    newAchievements.push(achievements.find(a => a.id === 'action-taker'));
  }
  
  // Strategic Planner
  if (actionPlan.length >= 10 && !newAchievements.find(a => a.id === 'strategic-planner')) {
    newAchievements.push(achievements.find(a => a.id === 'strategic-planner'));
  }
  
  return newAchievements;
};

export const calculateTotalPoints = (achievementsList) => {
  return achievementsList.reduce((total, achievement) => total + achievement.points, 0);
};

export default { achievements, progressMilestones, checkAchievements, calculateTotalPoints };
